import React from 'react';
import { PROFILE_KEYS } from './profile/productProfiles';
import StatusCell from './signals/StatusCell';
import PriceBand from './signals/PriceBand';
import { formatCurrency } from '../../utils/Utils';

// Summary card: image + name + price + the profile's verdict signals (reused from StatusCell).
export default function ProductCard({ row, profileKey, t, onOpen, onShowSellers, templateNameById, highlighted }) {
  if (!row) return null;
  let price = row.price;
  if (profileKey === PROFILE_KEYS.MARKET) price = row.competitorsMinPrice;
  else if (profileKey === PROFILE_KEYS.MARKETPLACE) price = row.mp_buybox_price;
  const ident = row.sku || row.ean || row.mpn || row.asin || row.barcode || '';
  const showBand = profileKey === PROFILE_KEYS.COMPETITIVE || profileKey === PROFILE_KEYS.DROPSHIPPING;
  const sellerCount = row.competitorsCount;
  return (
    <div role="button" tabIndex={0} className={`pux-card${highlighted ? ' pux-card--visited' : ''}`}
         onClick={() => onOpen(row)} onKeyDown={(e) => { if (e.key === 'Enter') onOpen(row); }}>
      <div className="pux-card-top">
        {row.image
          ? <img className="pux-card-img" src={row.image} alt="" onError={(e) => { e.target.style.visibility = 'hidden'; }} />
          : <div className="pux-card-img pux-card-img-empty" />}
        <div className="pux-card-price">{price != null ? formatCurrency(price, row.currency) : <span style={{ color:'#9ca3af' }}>-</span>}</div>
      </div>
      <div className="pux-card-name" title={row.name}>{row.name}</div>
      {ident && <div className="pux-card-sku">{ident}</div>}
      <div className="pux-card-verdict">
        <StatusCell row={row} profileKey={profileKey} t={t} templateNameById={templateNameById} />
        {showBand && <PriceBand price={row.price} min={row.competitorsMinPrice} max={row.competitorsMaxPrice} />}
      </div>
      {sellerCount > 0 && onShowSellers && (
        <button type="button" className="pux-expander pux-card-sellers"
                onClick={(e) => { e.stopPropagation(); onShowSellers(row); }}>
          <i className="pi pi-chevron-down" style={{ fontSize: '.7rem' }} /> {sellerCount} {t('product.seller')}
        </button>
      )}
    </div>
  );
}
